export default class Utl {
    static chkMustInput(item, txt) {
        // 必須入力チェック
        if (txt == "") {
            return item + "が未入力です。";
        }
        return "";
    }
    static chkNum(item, txt) {
        if (!txt.toString().match(/^[0-9]+$/)) {
            return item + "は半角数字のみを入力して下さい。";
        }
        return "";
    }
    static chkCanUseChars(item, txt) {
        if (txt.indexOf(" ") >= 0 || txt.indexOf("　") >= 0) {
            return item + "にスペースは使用できません。";
        }
        // 半角カナ
        const hc =
            "｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ";
        // 半角カナを検査
        for (let pos = 0; pos < txt.length; pos++) {
            if (hc.indexOf(txt.charAt(pos), 0) >= 0)
                return item + "に半角カナは使用できません。";
        }
        // 記号文字
        const sc = "\"!#$%&'()=~|\\-^{}[]+;*:,<.>/?_";
        // 記号文字を検査
        for (let pos = 0; pos < txt.length; pos++) {
            if (sc.indexOf(txt.charAt(pos), 0) >= 0)
                return item + "に半角記号文字は使用できません。";
        }
        // 漢字らしきもの
        var bKnj1 = txt.match(/^[一-龠]+$/);
        var bKnj2 = txt.match(/^[\u4E00-\u9FFF]+$/);
        // eslint-disable-next-line
        var bKnj3 = (txt.match(/^[\x01-\x7E\uFF65-\uFF9F]+$/) ? false : true);
        // 漢字らしきものかを検査
        if (!(bKnj1 || bKnj2 || bKnj3)) {
            return item + "に漢字以外は使用できません。";
        }
        //正常を返す
        return "";
    }

    static chkCanUseKana(item, txt) {
        if (!txt.match(/^[\u30A0-\u30FF\uFF65-\uFF9F]+$/)) {
            return item + "にカナ以外は使用できません。";
        }
        //正常を返す
        return "";
    }

    static chkMailAddress(item, txt) {
        if (txt.length > 49) {
            return item + "が長すぎます。";
        }
        if (txt.length != 0) {
            if (
                !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[-1-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    txt
                )
            ) {
                return item + "に誤りがあります。";
            }
        }
        return "";
    }

    static chkPassword(item, txt) {
        if (txt.match(/[^a-zA-Z0-9]/)) {
            return item + "は半角英数字のみを入力して下さい。";
        }

        if (txt.length < 8 || txt.length > 12) {
            return item + "は8桁以上、12桁以内で入力して下さい。";
        }
        //check() return
        if (!txt.match(/([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/)) {
            return item + "は半角英字と数字を組み合わせて入力して下さい。";
        }
        return "";
    }

    static chkUserID(item, txt) {
        let mes = this.chkNum(item, txt);
        if (mes.length != 0) return mes;
        return "";
    }
    static chkZipCode(item, txt) {
        let mes = this.chkNum(item, txt);
        if (mes.length != 0) return mes;
        if (txt.toString().length != 7) {
            return (item + "が７桁でありません。");
        }
        return "";
    }
}